import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface ConfettiState {
  showConfetti: boolean;
  setShowConfetti: (show: boolean) => void;
}

export const useConfettiStore = create<ConfettiState>()(
  persist(
    (set) => ({
      showConfetti: false,
      setShowConfetti: (show) => set({ showConfetti: show }),
    }),
    {
      name: 'confetti-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
